/**
 * ClassificationSeal — Brief 2A r7b canonical (Sprint Visual Agent B).
 *
 * Pill compacto (24x24) exibindo classe de sensibilidade (N1/N2/N3/N4)
 * canonical no Composer Linha 1. Display-only — interativo apenas via
 * tooltip.
 *
 * Variants canonical via .classification-seal--n{1|2|3|4} em global.css:
 *   - N1 → neutro com opacity 0.6 (pública)
 *   - N2 → cinza stone (restrita — default tenant)
 *   - N3 → amber (sensível)
 *   - N4 → red (crítica)
 *
 * ADR-064 (4 níveis canônicos LGPD) + DS v2.3.0 .class-badge family
 * paralela para Header (mantida via SensitivityBadge / ClassificationBadge).
 *
 * Esta variante (Seal compact 24x24) é específica do Composer canonical
 * standalone.html — distinta do .class-badge canonical do Header.
 */
export function ClassificationSeal({ level }: { level: number }): JSX.Element {
  const variant =
    level >= 1 && level <= 4 ? `classification-seal--n${level}` : 'classification-seal--n1';
  return (
    <span
      className={`classification-seal ${variant}`}
      title={`Sensibilidade N${level.toString()} (LGPD)`}
      aria-label={`Classificação N${level.toString()}`}
    >
      N{level}
    </span>
  );
}
